import type { ConversationTopicDetailDto } from '../api/client';

export function topicMessageTime(at: string): string {
  const date = new Date(at);
  return Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).format(date) : '';
}

/** Board projection only: no synthetic assistant message or automatic model turn. */
export function TopicFollowUpStatus({ detail, onOpen }: { detail: ConversationTopicDetailDto; onOpen: (submissionId: string) => void }) {
  const request = detail.topic.queue.at(-1);
  const reply = [...detail.transcript].reverse().find(e => e.role === 'assistant' && e.submissionId === request?.id);
  const items = detail.board?.items.filter(item => item.submissionId === request?.id) ?? [];
  if (!reply || !items.some(item => Date.parse(item.updatedAt) > Date.parse(reply.at))) return null;
  const latest = items.reduce((at, item) => item.updatedAt > at ? item.updatedAt : at, reply.at);
  const done = items.filter(item => item.state === 'concluido').length;
  const following = items.filter(item => item.state !== 'concluido' && item.owner !== 'dono').length;
  const human = items.filter(item => item.owner === 'dono' && item.state !== 'concluido').length;
  return <aside className="topic-follow-up-status" aria-label="Estado atualizado dos apontamentos" data-testid="topic-follow-up-status">
    <div><strong>Pedido {request?.messageSeq} · resultado atualizado</strong><time>{topicMessageTime(latest)}</time></div>
    <p>{done} de {items.length} concluídos · {following} com trabalho restante · {human} dependem de você.</p>
    <p className="topic-follow-up-history">A resposta abaixo, de {topicMessageTime(reply.at)}, é anterior a esta atualização.</p>
    <button type="button" onClick={() => onOpen(request!.id)}>Ver resultados e pendências</button>
  </aside>;
}
